export enum PostingType {
  Posting = 'posting',
}
